import React from 'react';
import PartyMaster from './PartyMaster';

function HandworkParties() {
  return (
    <PartyMaster
      title="Handwork Parties"
      modalTitle="Add Handwork Party"
      addButtonText="Add Handwork Party"
      searchPlaceholder="Search handwork parties..."
      partyCategory="HANDWORK_PARTIES"
      namePlaceholder="Handwork party name"
    />
  );
}

export default HandworkParties;
